import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';
import {
    ServiceMedicalProcedureObject,
} from '@libs/types/src/services/object-type/service/service-medical-procedure.object';
import { toSignal } from '@angular/core/rxjs-interop';
import { globalStore } from '../../../../../shared/shared.global-service';
import { selectServiceSettings } from '../../../../store/service/service.selectors';
import {
    COMMON_SERVICE_SETTINGS_DEFAULT,
} from '@libs/types/src/services/types/common-service-settings.type';
import { healthcareCalendarSettingsKey } from '../../../../../../utils/healthcare-calendar-settings.utils';

@Injectable()
export class ServicesProceduresDetailPageStore extends ComponentStoreV2Factory {

    schedulerSettings = toSignal(globalStore!.select(
        selectServiceSettings(healthcareCalendarSettingsKey(), COMMON_SERVICE_SETTINGS_DEFAULT),
    ));

    public procedure = computed<ServiceMedicalProcedureObject | null>(() => {
        return this.data.getServiceMedicalProcedures()?.['items']?.[0];
    });

}
